<template>
  <div>
    <v-dialog v-model="customShopModal" persistent width="550">
      <v-toolbar class="redColor text-white">
        <v-toolbar-title>{{
          $t("institutions.table.custom_shop")
        }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          color="white"
          @click="closeCustomShopModal"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-3">
        <v-progress-linear
          v-if="loading"
          color="#D32F2F"
          indeterminate
          rounded
          height="6"
        />
        <div class="pb-3">
          <!-- <v-alert
            :value="true"
            type="error"
            border="bottom"
            variant="outlined"
            prominent
            text
          >
            {{ $t('institutions.form.account') }}
          </v-alert> -->
        </div>
        <div class="pb-3">
          <v-text-field
            v-model="superAdminPassword"
            label="SuperAdmin Password"
            color="red-darken-1"
            prepend-icon="mdi-security"
            autocomplete="off"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword1 ? 'text' : 'password'"
            @click:append="showPassword1 = !showPassword1"
          />
          <v-text-field
            v-model="user_email"
            :label="$t('Username')"
            color="red-darken-1"
            prepend-icon="mdi-email"
            autocomplete="off"
            name="user-email"
            :disabled="!superAdminPassword"
          />
          <v-text-field
            id="password"
            v-model="password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('users.form.password')"
            prepend-icon="mdi-lock-outline"
            color="red-darken-2"
            :disabled="!superAdminPassword"
            @click:append="showPassword = !showPassword"
          />
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red-darken-1"
            variant="outlined"
            @click="closeCustomShopModal"
          >
            {{ $t("institutions.form.close") }}
          </v-btn>
          <v-btn
            color="green"
            variant="outlined"
            :disabled="checkDetails"
            @click="registerUser()"
          >
            {{ $t("institutions.form.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="shopErrorDialog" persistent width="500">
      <v-card class="pa-3">
        <v-alert :value="true" type="error">
          {{ shopResponse }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="shopErrorDialog = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="customShopUsersModal" width="500">
      <v-card class="pa-3">
        <div v-for="(user, index) in shopUsers" :key="index">
          <div class="col-12">
            <v-icon>mdi-account</v-icon> {{ user.username }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert" max-width="500">
      <v-alert v-model="alert" type="success" dismissible :value="true">
        {{ $t("institutions.form.verification_success") }}
      </v-alert>
    </v-dialog>
    <v-dialog v-model="success" max-width="300">
      <v-alert v-model="success" type="success" dismissible :value="true">
        {{ $t("institutions.form.success") }}
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import postRequest from "../../api/postRequest";

export default {
  components: {},
  data: () => ({
    institution_id: null,
    customShopModal: false,
    item: {
      googleId: "",
    },
    shopResponse: null,
    shopErrorDialog: false,
    loading: false,
    alert: false,
    inst: null,
    loadingSave: false,
    institutionDetails: null,
    // baseUrl: 'http://localhost:3000',
    baseUrl: "https://api.lekotech.com",
    rules: {
      required: [(v) => !!v || "Please fill this field"],
    },
    valid: false,
    success: false,
    user_email: "",
    password: "",
    confirm_password: "",
    superAdminPassword: "",
    showPassword: false,
    showPassword1: false,
    email: "",
    shopUsers: [],
    customShopUsersModal: false,
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    checkDetails() {
      return !(this.user_email && this.password && this.superAdminPassword);
    },
  },
  watch: {
    valid(value) {
      this.$emit("valid", value);
    },
  },
  methods: {
    openCustomShopModal(institution) {
      this.institution_id = institution._id;
      this.inst = institution;
      this.item.googleId = institution.googleMerchantId || "";
      this.user_email = "";
      this.password = "";
      this.customShopModal = true;
    },
    openCustomShopUsers(users) {
      this.shopUsers = users;
      this.customShopUsersModal = true;
    },
    registerUser() {
      this.loading = true;
      postRequest
        .object(
          "/custom-shop/register",
          {
            email: this.$store.getters.userEmail,
            username: this.user_email,
            password: this.password,
            superAdminPassword: this.superAdminPassword,
            institutions: [this.institution_id],
          },
          //  {
          //   headers: { authorization: localStorage.token },
          // },
        )
        .then((response) => {
          if (response && response.data && response.data.errorMsg) {
            this.shopResponse = response.data.errorMsg;
            this.shopErrorDialog = true;
          } else {
            this.alert = true;
            this.customShopModal = false;
            setTimeout(() => {
              this.alert = false;
            }, 3000);
            this.$emit("fetchInstitutionDetails");
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveGoogleDetails() {
      this.loading = true;
      axios
        .put(
          `${this.baseUrl}/institution/edit-google-merchant-details/${this.institution_id}`,
          { googleMerchantId: this.item.googleId },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          if (response && response.data && response.data.errorMsg) {
            this.shopResponse = response.data.errorMsg;
            this.shopErrorDialog = true;
          } else {
            this.alert = true;
            this.customShopModal = false;
            this.item.googleId =
              response.data && response.data.googleMerchantId
                ? response.data.googleMerchantId
                : "";
            setTimeout(() => {
              this.alert = false;
            }, 3000);
            this.$emit("fetchInstitutionDetails");
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeCustomShopModal() {
      this.customShopModal = false;
      this.$emit("fetchInstitutionDetails");
    },
  },
};
</script>
